module.exports = __webpack_public_path__ + "static/media/visible.f38b8863.svg";